import React, { useCallback } from 'react';
import { TimePicker } from '@atlaskit/datetime-picker';
import { Field as AkField, ErrorMessage as AkErrorMessage } from '@atlaskit/form';
import availableTimes from '@atlassian/jira-common-constants/src/datetimepicker-available-times';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { useLocale } from '@atlassian/jira-tenant-context-controller/src/components/locale/index.tsx';
import {
	EMPTY_TIME,
	INVALID_DATE,
	INVALID_TIME_RANGE,
	TIME_PICKER_FIELD_START,
} from '../../../../../../../../common/ui/constants.tsx';
import { getTimeFormatForTimePicker } from '../../../../../../../../common/utils/calendars/utils';
import { parseTime } from '../../../../../../../../common/utils/time';
import messages from './messages';
import { getValidateFunction } from './utils';

type Props = {
	isDisabled: boolean;
} & Intl & {
		fieldIdPrefix: string;
		fieldId: number;
		defaultValue: string;
		day: string;
	};

export const StartTimeView = ({
	intl: { formatMessage },
	fieldIdPrefix,
	fieldId,
	defaultValue,
	isDisabled,
	day = '',
}: Props) => {
	const locale = useLocale();
	// go/jfe-eslint
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const onValidate = useCallback(getValidateFunction(fieldIdPrefix, fieldId), [
		fieldId,
		fieldIdPrefix,
	]);
	const parseTimeWithUserLocale = useCallback((input: string): Date => parseTime(input), []);
	const name = `${fieldIdPrefix}${TIME_PICKER_FIELD_START}${fieldId}`;
	return (
		<AkField
			name={name}
			defaultValue={defaultValue}
			// @ts-expect-error - TS2322 - Type '(start: string, formData: { [key: string]: string; }) => "Invalid Date" | "Empty Time" | "Invalid Time Range" | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
			validate={onValidate}
		>
			{({ fieldProps: { value, onChange }, error }) => (
				<>
					<TimePicker
						locale={locale}
						defaultValue={value}
						onChange={onChange}
						// @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'boolean | undefined'.
						isInvalid={error}
						isDisabled={isDisabled}
						timeIsEditable
						times={availableTimes}
						parseInputValue={parseTimeWithUserLocale}
						// @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string | undefined'.
						timeFormat={getTimeFormatForTimePicker(locale)}
						testId={`servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.${name}`}
						label={formatMessage(messages.startTime, { time: value, day })}
					/>
					{error === EMPTY_TIME && (
						<AkErrorMessage>{formatMessage(messages.emptyStartTime)}</AkErrorMessage>
					)}
					{error === INVALID_DATE && (
						<AkErrorMessage>{formatMessage(messages.invalidStartTime)}</AkErrorMessage>
					)}
					{error === INVALID_TIME_RANGE && (
						<AkErrorMessage>{formatMessage(messages.invalidTimeRange)}</AkErrorMessage>
					)}
				</>
			)}
		</AkField>
	);
};

export const StartTime = injectIntl(StartTimeView);
